commonModule.factory('rolePermissionsService', ['imSessionVarsService', 'identityMgmntService', 'routes', 'additionalSecuritySections', '$q',
    function(imSessionVarsService, identityMgmntService, routes, additionalSecuritySections, $q) {
        var api =  {};

        function resolveResource(resourceName) {
            // translate SPAN resource to TLC view
            switch (resourceName){
                case 'ERT_SEARCH_QUOTE_PAGE':
                case 'ERT_VIEW_QUOTE_PAGE':
                case 'ERT_CONTRACT_SEARCH_PAGE':
                    return routes.search;
                case 'ERT_GENERATE_QUOTE_PAGE':
                    return routes.createQuote;
                case 'ERT_CONTRACT_CREATE_PAGE':
                    return routes.createContract;
                case 'ERT_DEALER_SETTINGS_PAGE':
                    return routes.dealerSettings;
                case 'ERT_DEALER_SEARCH_PAGE':
                    return routes.dealershipSearch;
                case 'ERT_OPEN_REMIT_PAGE':
                    return routes.remitRegister;
                case 'ERT_DEALER_PROFILE_PAGE':
                    return routes.dealerProfile;
                case 'ERT_USER_MANAGE_PAGE':
                    return routes.userManage;
                case 'ERT_CONTRACT_ACTIVITY':
                    return routes.contractActivity;
                case 'ERT_ADDITIONAL_MARKUP_DIALOG':
                    return additionalSecuritySections.additionalMarkup;
                case 'ERT_OVER_REMIT_DIALOG':
                    return additionalSecuritySections.overRemit;
                case 'ERT_LENDER_SETTINGS':
                case 'ERT_PROVIDER_MANAGE_VINS':
                case 'ERT_PRODUCT_ADMIN':
                case 'ERT_FORMS_CONFIGURATION_PAGE':
                case 'ERT_PRODUCT_CODES':
                case 'ERT_PROVIDER_SETTINGS':
                default:
                    return null;
            }
        }

        api.generateUserRoleRouteMap = function() {
            var deferred = $q.defer();
            //Save Roles and Privileges in session
            identityMgmntService.getRolesAndPrivileges()
                .then(function (response) { // resolved
                    if (response.length > 0) {
                        var userRoleRouteMap = {};
                        response[0].Roles.forEach(function(role) {
                            var roleRoute = role.RoleName.replace(/ /g, '_').toUpperCase();
                            userRoleRouteMap[roleRoute] = [routes.login, routes.welcome, routes.logout, routes.error, routes.showcaseLiteRedirect];
                            userRoleRouteMap[roleRoute] = userRoleRouteMap[roleRoute].concat(role.Privileges.map(function(priv) { return resolveResource(priv.ResourceName); }).filter(function(ele) { return ele; }));
                        });

                        imSessionVarsService.setRolesAndPrivileges(JSON.stringify(userRoleRouteMap));
                        deferred.resolve(userRoleRouteMap);
                    }
                },
                function(err){
                    deferred.reject(err);
                });
            return deferred.promise;
        };

        return api;
    }
]);
